import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Button from '../Button'
import { useToggle } from '../utils/hooks'

const EditCell = ({ isTextWrap, value, onSubmit }) => {
  const [isEdit, toggleEdit] = useToggle()
  const [editText, setEditText] = useState(value)
  const [isSubmitting, toggleSubmitting] = useToggle()

  useEffect(() => {
    setEditText(value)
  }, [value])

  const handleClick = (event) => {
    if (!event.target.className.includes('active-edit-controls') && !event.target.className.includes('resize-handle')) {
      toggleEdit(false)
      setEditText(value)
    }
  }

  useEffect(() => {
    if (isEdit) {
      document.addEventListener('mousedown', handleClick)
      return () => {
        document.removeEventListener('mousedown', handleClick)
      }
    }
  }, [handleClick, isEdit])

  return isEdit
    ? (
      <div className={`d-flex align-items-center active-edit-controls w-100 h-100 ${isEdit ? 'edit-background-color' : ''}`}>
        <div className='d-flex active-edit-controls w-100 p-2'>
          <input
            type='text'
            className='form-control rounded-0 me-1 active-edit-controls'
            disabled={isSubmitting}
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
          />
          <Button
            ghost
            className='save-cancel active-edit-controls'
            disabled={isSubmitting}
            onClick={async() => {
              toggleSubmitting(true)
              await onSubmit(editText)
              toggleSubmitting(false)
              toggleEdit(false)
            }}
          >
            {isSubmitting
              ? <span className='fas fa-spinner fa-spin active-edit-controls' />
              : <span className='fas fa-check text-success active-edit-controls' />
            }
          </Button>
          <Button
            ghost
            className='save-cancel text-muted active-edit-controls'
            disabled={isSubmitting}
            onClick={toggleEdit}
          >
            <span className='fas fa-xmark active-edit-controls' />
          </Button>
        </div>
      </div>
    )
    : (
      <div className='d-flex justify-content-between align-items-center w-100 position-relative p-2'>
        <span className={isTextWrap ? '' : 'text-truncate'}>{value}</span>
        <Button
          variant='light'
          className='position-absolute text-primary end-0 edit me-2'
          onClick={toggleEdit}
        >
          <span className='fas fa-pen' />
        </Button>
      </div>
    )
}

EditCell.propTypes = {
  value: PropTypes.any,
  onSubmit: PropTypes.func,
  isTextWrap: PropTypes.array,
  name: PropTypes.string
}

export default EditCell
